module.exports = __webpack_public_path__ + "img/icon_file_on.c37b5082.svg";